<template>
  <div>
    <!-- <pre>{{ result_value }}</pre> -->
    <!-- <pre>{{ this.select_pump }}</pre>
    <pre>{{datacollection_kwh}}</pre>
    <pre v-for="i in result_value.chart" :key="i">{{ i.Level_2S }}</pre> -->
    <!-- <pre>{{ Object.keys(result_value.chart) }}</pre> -->
    <!-- <div class="div_row1">
      <div class="div_box1_1 divcard3">
        <powerconsumption
          :select_pump="select_pump"
          :option_pump="option_pump"
          :logdata="logdata"
        />
      </div>
      <div class="div_box1_2 divcard3">
    
      </div>
    </div> -->
    <timeinterval
      :value_time="result_value_time"
      :station="3"
      v-on:fSelect_timeinterval="fSelect_timeinterval"
    /><br />
    <div class="container_grid-1">
      <div class="c1 card-div">
        <powerconsumption
          :select_pump="select_pump"
          :option_pump="option_pump"
          :result_value="result_value"
          v-on:fSelect_pump="fSelect_pump"
        />
      </div>
      <div class="c2 card-div">
        <powerconsumptiongraph
          color="#4DC4FF"
          :datacollection="datacollection_kwh"
          :chartdata="chartdata"
          :value_graph="value_graph"
        />
      </div>
    </div>
    <br />
    <div class="container_grid-2">
      <div class="card-div margin-top-10 g1_2 margin-left-20">
        <chartaa
          colorgraph="#A1DE96"
          :datacollection="datacollection_lv1s"
          :header="'Pond Water Level'"
        />
      </div>
      <div class="card-div margin-top-10 g1_1">
        <textlevel
          :header="'Pond Water Level'"
          :pump_id="'LV1'"
          :pump_station="3"
          :value="result_value.Level_1S ? result_value.Level_1S.toFixed(2) : '-'"
          :a="true"
          :show_setting="true"
        />
      </div>
      <div class="card-div margin-top-10 g2_1">
        <textlevel
          :header="'Canal Water Level'"
          :pump_id="'LV2'"
          :pump_station="3"
          :value="result_value.Level_2S ? result_value.Level_2S.toFixed(2): '-'"
          :a="true"
          :show_setting="true"
        />
      </div>
      <div class="card-div margin-top-10 g2_2 margin-left-20">
        <chartaa
          colorgraph="#b38dff"
          :datacollection="datacollection_lv2s"
          :header="'Canal Water Level Trend'"
        />
      </div>
      <!-- <div class="card-div margin-top-10 g3_2 margin-left-20">
        <chartaa colorgraph="#EF9BD8" :header="'Rain Volume Trend'" />
      </div> -->
      <!-- <div class="card-div margin-top-10 g3_1">
        <textlevel :header="'Rain Volume'" value="2310.15" :a="false" />
      </div> -->
      <div class="card-div margin-top-10 g4_1-1">
        <waterpump
          v-if="result_value.Mode_M1"
          :header="'Water Pump 01'"
          :pump_id="1"
          :pump_station="3"
          :setting_pump="setting_pump[0]"
          :runtime="result_value.Hour_1_new"
          :kwh_status="result_value.kWh_1_day"
          :control_status="result_value.Mode_M1"
          :mode_pw="result_value.Mode_Web_M1"
          :status_overload="result_value.Status_Overload_M1"
          :status="result_value.Status_Run_M1"
        />
      </div>
      <div class="card-div margin-top-10 g4_1-2">
        <waterpump
          v-if="result_value.Mode_M2"
          :header="'Water Pump 02'"
          :setting_pump="setting_pump[1]"
          :pump_id="2"
          :pump_station="3"
          :control_status="result_value.Mode_M2"
          :kwh_status="result_value.kWh_2_day"
          :runtime="result_value.Hour_2_new"
          :mode_pw="result_value.Mode_Web_M2"
          :status_overload="result_value.Status_Overload_M2"
          :status="result_value.Status_Run_M2"
        />
      </div>
      <div class="card-div margin-top-10 g4_1-3">
        <waterpump
          v-if="result_value.Mode_M3"
          :header="'Water Pump 03'"
          :setting_pump="setting_pump[2]"
          :pump_id="3"
          :pump_station="3"
          :control_status="result_value.Mode_M3"
          :kwh_status="result_value.kWh_3_day"
          :runtime="result_value.Hour_3_new"
          :mode_pw="result_value.Mode_Web_M3"
          :status_overload="result_value.Status_Overload_M3"
          :status="result_value.Status_Run_M3"
        />
      </div>
      <div class="card-div margin-top-10 g4_2 margin-left-20">
        <tabledaily
          maxheight="900px"
          :data="result_value.water_pump"
          :header="table_pump"
          header_table="Water Pump Runtime"
        />
      </div>
      <div class="card-div margin-top-10 g5 margin-left-20">
        <tabledaily
          maxheight="1600px"
          :data="result_value.Liquid"
          :header="table_liquite"
          header_table="Liquid Usage daily"
        />
      </div>
    </div>
    <br />
    <displaycamera :img_camera="img_camera" />
  </div>
</template>

<script>
import chartaa from "./components/graph/chart.vue";
import textlevel from "./components/div/divlevel.vue";
import waterpump from "./components/div/waterpump.vue";
import tabledaily from "./components/div/table.vue";
import powerconsumptiongraph from "./components/power_consumption_graph.vue";
import powerconsumption from "./components/power_consumtion.vue";
import timeinterval from "./components/div/TimeInterval.vue";
import displaycamera from "./components/div/display_camera.vue";
export default {
  components: {
    chartaa,
    textlevel,
    waterpump,
    tabledaily,
    powerconsumption,
    powerconsumptiongraph,
    timeinterval,
    displaycamera,
  },
  data() {
    return {
      img_camera: {},
      result_value: [],
      table_liquite: {
        header: [
          "Timestamp",
          "Power Consumption",
          "Pond Water Level",
          "Canal Water Level",
        ],
        keys: ["date", "power_consumption", "Level_1S", "Level_2S"],
        // unit: ["", "kWh", "M", "M"],
      },
      setting_pump: [
        {
          select: "Auto",
          type: "day",
          name: ";pppp",
          day: 1,
          starttime: "01:58:00",
          endtime: "11:59:00",
        },
        {
          select: "Auto",
          type: "day",
          name: ";pppp",
          day: 1,
          starttime: "01:58:00",
          endtime: "11:59:00",
        },
        {
          select: "Auto",
          type: "day",
          name: ";pppp",
          day: 1,
          starttime: "01:58:00",
          endtime: "11:59:00",
        },
      ],
      table_pump: {
        header: [
          "Timestamp",
          "Water Pump 01",
          "Water Pump 02",
          "Water Pump 03",
        ],
        keys: ["date", "Hour_1_new", "Hour_2_new", "Hour_3_new"],
        unit: ["", "kWh", "M", "M"],
      },
      color: ["#4DC4FF", "#b38dff"],
      chartdata: {
        labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
        value: [22, 19, 22, 11, 16, 11, 10],
        value2: [10, 14, 13, 15, 11, 24, 18],
      },
      select_pump: 0,
      result_value_time: {},
      option_pump: [
        {
          text: "All Pump",
          value: 0,
          key1: "kWh_all_day",
          key2: "kWh_all_month",
          key3: "kWh_all_year",
        },
        {
          text: "Pump 01",
          value: 1,
          key1: "kWh_1_day",
          key2: "kWh_1_month",
          key3: "kWh_1_year",
        },
        {
          text: "Pump 02",
          value: 2,
          key1: "kWh_2_day",
          key2: "kWh_2_month",
          key3: "kWh_2_year",
        },
        {
          text: "Pump 03",
          value: 3,
          key1: "kWh_3_day",
          key2: "kWh_3_month",
          key3: "kWh_3_year",
        },
      ],
      users_1: [
        {
          id: 1,
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
        },
        {
          id: 4,
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
        },
      ],
      users_2: [
        {
          id: 1,
          name: "Leanne Graham",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          website: "ramiro.info",
        },
      ],
      // option_power_consumption: [],
      datacollection_kwh: {
        labels: [],
        datasets: [
          {
            label: "Active Power",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "#4DC4FF",
          },
        ],
      },
      datacollection_lv1s: {
        labels: [],
        datasets: [
          {
            label: "Water Level",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "#A1DE96",
          },
        ],
      },
      datacollection_lv2s: {
        labels: [],
        datasets: [
          {
            label: "Water Level",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "#b38dff",
          },
        ],
      },
      value_graph: { max: null, min: null, avg: null },
    };
  },
  methods: {
    logdata(a) {
      this.select_pump = a;
    },
    fSelect_pump(select) {
      // console.log(select);
      this.select_pump = select.value;
      this.graphpc(this.select_pump);
    },
    graphpc(a) {
      if (!this.result_value.chart) return;

      let labels = [];
      let data_kwh = [];
      let total = 0;
      // let data_lv2s = [];

      labels = Object.keys(this.result_value.chart);
      if (a == 0) {
        Object.keys(this.result_value.chart).forEach((element) => {
          data_kwh.push(this.result_value.chart[element].kwh);
        });
      } else if (a == 1) {
        Object.keys(this.result_value.chart).forEach((element) => {
          data_kwh.push(this.result_value.chart[element].kWh_1);
        });
      } else if (a == 2) {
        Object.keys(this.result_value.chart).forEach((element) => {
          data_kwh.push(this.result_value.chart[element].kWh_2);
        });
      } else if (a == 3) {
        Object.keys(this.result_value.chart).forEach((element) => {
          data_kwh.push(this.result_value.chart[element].kWh_3);
        });
      }
      this.value_graph.max = Math.max.apply(Math, data_kwh);
      this.value_graph.min = Math.min.apply(Math, data_kwh);
      for (var i = 0; i < data_kwh.length; i++) {
        total += parseFloat(data_kwh[i]);
      }
      this.value_graph.avg = total / data_kwh.length;
      this.datacollection_kwh.datasets[0].data = data_kwh;
      this.datacollection_kwh.labels = labels;
    },
    graphlv1s() {
      let labels = [];
      let data_lv1s = [];
      let data_lv2s = [];
      // console.log(this.result_value.chart);
      labels = Object.keys(this.result_value.chart);
      Object.keys(this.result_value.chart).forEach((element) => {
        // console.log(this.result_value.chart[element].Level_1S);
        data_lv1s.push(this.result_value.chart[element].Level_1S);
        data_lv2s.push(this.result_value.chart[element].Level_2S);
      });
      this.datacollection_lv1s.datasets[0].data = data_lv1s;
      this.datacollection_lv1s.labels = labels;
      this.datacollection_lv2s.datasets[0].data = data_lv2s;
      this.datacollection_lv2s.labels = labels;
    },
  },
  async mounted() {
    this.$WSS.connect("FPS-demo");
    this.$WSS.emit("FPS-demo", 3);
    this.$WSS.emit("FPS-demo-setting", { stasion: 3 });
    this.$WSS.on("connect", () => {
      // console.log("socket id", this.$WSS.socket().id);
    });
    this.$WSS.on("FPS-demo-3", (messageNew) => {
      console.log("FPS-demo-3", messageNew, this.$moment().format("HH:mm:ss"));
      this.result_value = {...this.result_value, ...messageNew.message};
      console.log(this.result_value)
      this.img_camera.inside = this.result_value.image1;
      this.img_camera.outside = this.result_value.image2;
      this.graphlv1s();
      this.graphpc(this.select_pump);
    });
    this.$WSS.on("FPS-demo-setting", (messageNew) => {
      // console.log(
      //   "FPS-demo-setting",
      //   messageNew,
      //   this.$moment().format("HH:mm:ss")
      // );
      this.result_value_time = messageNew.message.settings;
      // console.log(messageNew.message);
    });
    // this.$WSS.on("FPS-demo-setpump", (messageNew) => {
    //   console.log(
    //     "FPS-demo-setpump",
    //     messageNew,
    //     this.$moment().format("HH:mm:ss")
    //   );
    // });
    // this.$API.get(`lkb/image/5/1`).then((result) => {
    //   console.log(result.data);
    //   this.img_camera.inside = result.data.file;
    //    this.img_camera.outside = result.data.file;
    // });
  },
  beforeDestroy() {
    this.$WSS.disconnect();
  },
};
</script>

<style scoped>
.container_grid-1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 15px 20px;
  grid-auto-flow: row;
  grid-template-areas: "c1 c1 c2 c2 c2";
}

.c1 {
  grid-area: c1;
}

.c2 {
  grid-area: c2;
}

.container_grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 15px 20px;
  width: 100%;
  grid-auto-flow: row;
  grid-template-areas:
    "g1_1 g1_1 g1_2  g1_2 g1_2 g1_2 g5 g5 g5 g5 g5 "
    "g2_1 g2_1 g2_2 g2_2 g2_2 g2_2 g5 g5 g5 g5 g5"
    /* "g3_1 g3_1 g3_2 g3_2 g3_2 g3_2 g5 g5 g5 g5 g5" */
    "g4_1-1 g4_1-1 g4_2 g4_2 g4_2  g4_2 g5 g5 g5 g5 g5"
    "g4_1-2 g4_1-2 g4_2 g4_2  g4_2 g4_2 g5 g5 g5 g5 g5"
    "g4_1-3 g4_1-3 g4_2 g4_2 g4_2 g4_2 g5 g5 g5  g5 g5";
}
.card-div {
  background: white;
  border-radius: 30px;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.margin-top-10 {
  /* margin-top: 10px; */
}
.margin-left-20 {
  /* margin-left: 20px; */
}
.g1_2 {
  grid-area: g1_2;
}
.col1 {
  width: 20%;
}
.col2 {
  width: 30%;
}
.col3 {
  width: 50%;
}
.g1_1 {
  grid-area: g1_1;
  background-image: url("../../../../assets/images/NikhomLatKrabang/Pond Water Level .gif");
  background-size: cover;
}

.g2_1 {
  grid-area: g2_1;
  background-image: url("../../../../assets/images/NikhomLatKrabang/Canal Water Level.gif");
  background-size: cover;
}

.g2_2 {
  grid-area: g2_2;
}

.g3_2 {
  grid-area: g3_2;
}

.g3_1 {
  grid-area: g3_1;
  background-image: url("../../../../assets/images/NikhomLatKrabang/Rain Volume.gif");
  background-size: cover;
}

.g4_1-1 {
  grid-area: g4_1-1;
}

.g4_1-2 {
  grid-area: g4_1-2;
}

.g4_1-3 {
  grid-area: g4_1-3;
}

.g4_2 {
  grid-area: g4_2;
}

.g5 {
  grid-area: g5;
}
@media screen and (max-width: 1180px) {
  .container_grid-2 {
    display: grid;
    grid-template-columns: 1fr 0fr 1fr 1fr 1fr 0fr 1fr 1fr 1fr 1fr;
    grid-template-areas:
      "g1_1 g1_1   g1_1      g1_2  g1_2  g1_2 g1_2     g5 g5 g5 g5 "
      "g2_1 g2_1   g2_1       g2_2  g2_2  g2_2 g2_2        g5 g5 g5 g5"
      "g4_1-1 g4_1-1  g4_1-1   g4_2  g4_2  g4_2 g4_2         g5 g5 g5 g5"
      "g4_1-2 g4_1-2   g4_1-2 g4_2  g4_2  g4_2   g4_2     g5 g5 g5 g5"
      "g4_1-3 g4_1-3  g4_1-3 g4_2  g4_2 g4_2   g4_2    g5 g5 g5 g5";
  }
}
@media screen and (max-width: 700px) {
  .container_grid-1 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .container_grid-2 {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }
}
</style>